import axios from "axios";
import "./App.css";

function App() {
  const download = () => {
    axios
      .post("https://3.21.113.161/download-dns-profile")
      .then((res) => {
        const downloadContent = res.data.data.replace(
          /<string>NextDNS \(1916e8\)<\/string>/,
          `<string>GlacierDNS \(test\)</string>`
        );
        const blob = new Blob([downloadContent], { type: "application/xml" });

        // Create a download link
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "Glacier DNS(test).mobileconfig";

        // Click the link to trigger the download
        a.click();

        // Clean up the URL.createObjectURL by revoking the object URL
        URL.revokeObjectURL(a.href);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="App">
      <button onClick={download}>Download</button>
    </div>
  );
}

export default App;
